const getDemoLink = (peacock = false) => {
  if (peacock) {
    return 'https://info.upshow.tv/get-a-demo-peacock-upshow';
  }

  return 'https://www.upshow.tv/get-a-demo/';
};

export default getDemoLink;

export const isValidEmail = email => {
  const regex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/;
  return !!email && email.length !== 0 && regex.test(email);
};

export const shouldShowPromoCodeMessage = () => {
  const currentDate = new Date();
  const promoStartDate = new Date('2024-01-03');
  const promoEndDate = new Date('2024-01-14T00:00:00-05:00'); // 01/14 at 00 UTC-5

  return currentDate >= promoStartDate && currentDate < promoEndDate;
};
